import { inject, Injectable } from '@angular/core';
import { firstValueFrom, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpBackend, HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class AccountsService {
  accountId: string | null = null;
  private fetchPromise: Promise<void> | null = null;
  private _http = new HttpClient(inject(HttpBackend));


  ensureAccountId(): Promise<void> {
    if (this.accountId) {
      return Promise.resolve();
    }

    if (!this.fetchPromise) {
      this.fetchPromise = firstValueFrom(this.getAccountIdApi())
        .then((res: any) => {
          this.accountId = res;
        })
        .catch((err) => {
          console.error('Failed to fetch accountId', err);
          this.fetchPromise = null;
          this.accountId = null;
        });
    }

    return this.fetchPromise;
  }

  reset() {
    this.accountId = null;
    this.fetchPromise = null;
  }

  getAccountIdApi(): Observable<number> {
    const apiUrl = environment.baseAPIUrl;
    return this._http.get<number>(`${apiUrl}/payment-account/v1/mobile/accounts/default`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
        'Accept': "application/json",
        "Accept-Language": localStorage.getItem('selectedLanguage') || 'en',
      }
    });
  }
}
